
import { computed } from '@vue/composition-api';
import type { Product } from '~/type/product/Product';
import TSPrice from '~/components/ts-components/TSPrice/TSPrice.vue';
import TSBonusCount from '~/components/ts-components/TSBonusCount/TSBonusCount.vue';
interface Props {
  /**
  * Массив с товарами
  */
  items: Product[];
  /**
  * Число выводимых товаров в сетке.  Поддерживаются значения 1-6 и 9
  */
  count: 1 | 2 | 3 | 4 | 5 | 6 | 9;
  /**
  * С какой стороны выводить большую картинку
  */
  productAlign: 'left' | 'right';
  /**
  * Делать ли изображения "ленивыми"
  */
  photoLazyload: boolean;
}
const __sfc_main = {};
__sfc_main.props = {
  items: {
    key: "items",
    required: true,
    type: Array
  },
  count: {
    key: "count",
    required: false,
    type: Number,
    default: 1
  },
  productAlign: {
    key: "productAlign",
    required: false,
    type: String,
    default: 'right'
  },
  photoLazyload: {
    key: "photoLazyload",
    required: false,
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const countProduct = computed(() => {
    if (props.count > props.items?.length) return Math.min(6, props.items.length);else return props.count;
  });
  function priceSize(index: any) {
    if (countProduct.value < 3 || countProduct.value >= 3 && index === 0) return 'big';else return 'small';
  }
  return {
    emit,
    countProduct,
    priceSize
  };
};
__sfc_main.components = Object.assign({
  TSBonusCount,
  TSPrice
}, __sfc_main.components);
export default __sfc_main;
